export enum StatementType {
  Estimated = 'Prévisionnel',
  Contradictory = 'Contradictoire'
}
